import { useEffect, useRef } from "react";
import gsap from "gsap";
import  "../styles/cardFan.css";

const CARD_COUNT = 5;
// Fan tuning — THESE control the look
const SPREAD_X = 180; // wider = bigger fan
const ROTATION = 15; // degrees from center to edge
const DEPTH = 100;   // z depth separation

export default function FanHover() {


        const cardsRef = useRef<(HTMLDivElement | null)[]>([]);

        useEffect(() => {
            const cards = cardsRef.current.filter(
                (el): el is HTMLDivElement => el !== null
            );

            if (!cards.length) return;

            const center = (cards.length - 1) / 2;

            // Initial wide fan layout
            gsap.set(cards, {
                xPercent: -50,
                yPercent: -50,
                left: "50%",
                top: "50%",
                transformPerspective: 1200,
                transformOrigin: "bottom center",
                rotation: (i) =>
                    -ROTATION + (i * (ROTATION * 2)) / (cards.length - 1),
                x: (i) => (i - center) * SPREAD_X,
                y: (i) => Math.abs(i - center) * 14,
                z: (i) => -Math.abs(i - center) * DEPTH,
                scale: 0.95,
            });


            // Per-card hover interactions
            cards.forEach((card, index) => {
                const onEnter = () => {
                    gsap.killTweensOf(card);

                    gsap.to(card, {
                        duration: 0.3,
                        ease: "power3.out",
                        y: "-=25",
                        z: 130,
                        scale: 1.05,
                    });

                    // dim others
                    cards.forEach((other, i) => {

                    });
                };

                const onLeave = () => {
                    gsap.killTweensOf(card);

                    gsap.to(card, {
                        duration: 0.3,
                        ease: "power3.out",
                        y: Math.abs(index - center) * 14,
                        z: -Math.abs(index - center) * DEPTH,
                        scale: 0.95,
                    });

                    cards.forEach((other) => {
                        gsap.to(other, { duration: 0.3, opacity: 1 });
                    });
                };

                card.addEventListener("mouseenter", onEnter);
                card.addEventListener("mouseleave", onLeave);

                return () => {
                    card.removeEventListener("mouseenter", onEnter);
                    card.removeEventListener("mouseleave", onLeave);
                };
            });
        }, []);

        return (
            <section className="relative w-full h-screen overflow-hidden bg-gradient-to-b from-[#A574BFcc] to-[#A574BF00] flex flex-col items-center justify-center py-20">
                <p className="absolute top-10 text-white text-9xl  w-full text-center ">
                    Socials
                </p>
            <div className="fan-stage flex items-center justify-center w-full h-full">
                <div className="fan-wrapper relative w-full max-w-[1200px] h-[420px]">
                {Array.from({ length: CARD_COUNT }).map((_, i) => (
                        <div
                            key={i}
                            className="fan-card min-w-32"
                            ref={(el) => {
                                cardsRef.current[i] = el;
                            }}
                        >
                            <img src={`https://picsum.photos/300/600?random=${i}`} alt={`Card ${i + 1}`} className="w-full h-full object-cover rounded-3xl shadow-lg rounded-2xl z-20" />
                        </div>
                    ))}
                </div>
            </div>

                <div className="absolute bottom-10 w-full text-center text-white text-3xl  mt-10">

                    <p>follow us on social media</p>
                    <div className="flex items-center justify-center w-full h-full">

                        <a href="https://facebook.com" className="m-4 text-white text-3xl hover:text-[#cccccc]">Linkdin</a>
                        <a href="https://instagram.com" className="m-4 text-white text-3xl hover:text-[#cccccc]">Instagram</a>
                    </div>
                </div>
            </section>
        );
    }